module.exports = __webpack_public_path__ + "static/media/32.f787a9a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/32.png
// module id = 993
// module chunks = 0